<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Großflächen · PV</p>

      <h2 class="presentation-page__title">Großflächen-PV von der Fläche bis zur Inbetriebnahme</h2>

      <p class="presentation-page__text">
        Sechs Leistungsschritte — wir übernehmen alles oder gezielt einzelne Phasen.
      </p>

      <div
        class="presentation-page__body presentation-page__body--split presentation-page__body--split-media-40"
      >
        <div class="presentation-page__column presentation-page__column--text">
          <ul class="presentation-page__list">
            <li v-for="item in listItems" :key="item">{{ item }}</li>
          </ul>
        </div>

        <div class="presentation-page__column presentation-page__column--media">
          <figure class="presentation-page__figure">
            <img
              class="presentation-page__image"
              src="/img/master_presentation/master_presentation_page_26.jpg"
              alt="Freiflächen-Photovoltaikanlage im Bau"
            />
          </figure>
          <p class="presentation-page__image-caption bg-blue">Freifläche · Multi-MW-Skalierung</p>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage26',

  components: { PrintPageLandscape, PresentationPage },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      listItems: [
        'Identifikation und vertragliche Sicherung geeigneter Flächen — Raumordnung, Umweltauflagen, Netzverfügbarkeit',
        'Vollständige Projektentwicklung bis zur Baureife inkl. Genehmigungsmanagement und Ausführungsplanung',
        'Detaillierte technische Auslegung der PV-Anlage inkl. Mittel- und Hochspannungs-Umspannwerken',
        'Komplettes Netzanschlussmanagement — von der Abstimmung mit dem Netzbetreiber bis zur erfolgreichen Einspeisung',
        'Eigenständige EPC-/Turnkey-Realisierung mit Verantwortung für Bau, Bauleitung, Qualität, Termine und Kosten',
        'Übergabe schlüsselfertiger Anlagen inkl. Inbetriebnahme, Dokumentation und Abnahmefähigkeit',
      ],
    };
  },
};
</script>
